import type { Product } from './eto-app';

function OverviewSection({ proxy, componentName, componentsLoading, error, etoProduct, serialNumber, euImporterAddress, euRepresentativeAddress, i18n }: {
    proxy: string;
    componentName: string;
    componentsLoading: boolean;
    error: string | null;
    etoProduct: Product | null;
    serialNumber: string;
    euImporterAddress?: string;
    euRepresentativeAddress?: string;
    i18n: (key: string) => string;
}) {
    return (
        <>
            {componentsLoading && 
                <div className={`${componentName}__table-section-header-skeleton ${componentName}__loading-animation`}></div>
            }
            <div className={`${componentName}__table-container`}>
                <table className={`${componentName}__table`}>
                    {componentsLoading &&
                        <tbody>
                            {new Array(6).fill(0).map((_, index) => (
                                <tr key={index} className={`${componentName}__table-row ${componentName}__table-row-skeleton`}>
                                    <th className={`${componentName}__table-cell-skeleton`}>
                                        <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                                    </th>
                                    <td className={`${componentName}__table-cell-skeleton`}>
                                        <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    }
                    {!componentsLoading && !error &&
                        <tbody>
                            {etoProduct?.id && <tr className={`${componentName}__table-row`}>
                                <th className={`${componentName}__table-cell`}>{i18n('Unique Product Identifier')}</th>
                                <td className={`${componentName}__table-cell`}>{proxy || etoProduct?.id}</td>
                            </tr>}
                            <tr className={`${componentName}__table-row`}>
                                <th className={`${componentName}__table-cell`}>{i18n('Serial Number')}</th>
                                <td className={`${componentName}__table-cell`}>{serialNumber}</td>
                            </tr>
                            {euImporterAddress && <tr className={`${componentName}__table-row`}>
                                <th className={`${componentName}__table-cell`}>{i18n('EU Importer Address')}</th>
                                <td className={`${componentName}__table-cell`} dangerouslySetInnerHTML={{ __html: euImporterAddress }}></td>
                            </tr>}
                            {euRepresentativeAddress && <tr className={`${componentName}__table-row`}>
                                <th className={`${componentName}__table-cell`}>{i18n('EU Authorized Representative Address')}</th>
                                <td className={`${componentName}__table-cell`} dangerouslySetInnerHTML={{ __html: euRepresentativeAddress }}></td>
                            </tr>}
                        </tbody>
                    }
                </table>
            </div>
        </>
    );
}

export default OverviewSection;